import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { EditTrailToolbarSections } from '../components/EditTrailToolbar';

export type DiToolingState = {
  showTrailEditToolbar?: boolean;
  trailEditToolbarFocusSection?: EditTrailToolbarSections;
};

export const initialState: DiToolingState = {
  showTrailEditToolbar: false,
  trailEditToolbarFocusSection: undefined
};

export const diToolingSlice = createSlice({
  name: 'di-tooling',
  initialState,
  reducers: {
    // Update with a type
    openTrailEditToolbar: (state, action: PayloadAction<EditTrailToolbarSections | undefined>) => {
      state.showTrailEditToolbar = true;
      state.trailEditToolbarFocusSection = action.payload;
    },
    closeTrailEditToolbar: state => {
      state.showTrailEditToolbar = false;
      state.trailEditToolbarFocusSection = undefined;
    }
  }
});

export const { openTrailEditToolbar, closeTrailEditToolbar } = diToolingSlice.actions;

export const diToolingReducer = diToolingSlice.reducer;
